import React from 'react';
import { useGlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const { store, currentLanguage } = useGlobalContext();
  const lang = currentLanguage?.code ? currentLanguage.code : store.default_language;

  const goTo = (path) => {
    window.location.href = path;
  };
  
  const linkStyle = {
    display: 'inline-block',
    padding: '12px',
    margin: '0 5px',
    color: "#666",
    size: "20px",
    cursor: 'pointer'
  };
  
  return (
    <footer className="footer" id="footer">
      <div className="wrapper">
        <span style={{ color: "#666" }}>
          <a
            href="/detail"
            style={linkStyle}
            role="button"
            tabIndex={0}
            translate="no"
            aria-label={t('En savoir plus')}
          >
            {t('En savoir plus')}
          </a>
          {" |"}
        </span>
        <span style={{ color: "#666" }}>
          {store.cgvExternalLink && store.cgvExternalLink[lang] && store.cgvExternalLink[lang] !== '' ? (
            <a
              href={store.cguExternalLink[lang]}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              translate="no"
              aria-label={`${t('CGV')} (${t('S\'ouvre dans un nouvel onglet')})`}
            >
              {t('CGV')}
              <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
            </a>
          ) : (
            <a
              onClick={() => goTo('/CGV')}
              style={linkStyle}
              role="button"
              tabIndex={0}
              translate="no"
            >
              {t('CGV')}
            </a>
          )}
          {" |"}
        </span>

        <span style={{ color: "#666" }}>
          {store.cguExternalLink && store.cguExternalLink[lang] && store.cguExternalLink[lang] !== '' ? (
            <a
              href={store.cguExternalLink[lang]}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              translate="no"
              aria-label={`${t('CGU')} (${t('S\'ouvre dans un nouvel onglet')})`}
            >
              {t('CGU')}
              <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
            </a>
          ) : (
            <a
              onClick={() => goTo('/CGU')}
              style={linkStyle}
              role="button"
              tabIndex={0}
              translate="no"
            >
              {t('CGU')}
            </a>
          )}
          {" |"}
        </span>

        <span style={{ color: "#666" }}>
          {store.personalInfosExternalLink && store.personalInfosExternalLink[lang] && store.personalInfosExternalLink[lang] !== '' ? (
            <a
              href={store.personalInfosExternalLink[lang]}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              translate="no"
              aria-label={`${t('Vos informations personnelles')} (${t('S\'ouvre dans un nouvel onglet')})`}
            >
              {t('Vos informations personnelles')}
              <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
            </a>
          ) : (
            <a
              href="/infos"
              style={linkStyle}
              role="button"
              tabIndex={0}
              translate="no"
              aria-label={t('Vos informations personnelles')}
            >
              {t('Vos informations personnelles')}
            </a>
          )}
          {" |"}
        </span>

       
          {store.contact && store.contact[lang] && store.contact[lang].type === 'url' ? (
            <a
              href={store.contact[lang].data}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              translate="no"
              aria-label={`${t('Contact')} (${t('S\'ouvre dans un nouvel onglet')})`}
            >
              {t('Contact')}
              <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
            </a>
          ) : store.contact && store.contact[lang] && store.contact[lang].type === 'email' ? (
            <a
              href={`mailto:${store.contact[lang].data}`}
              style={linkStyle}
              translate="no"
              aria-label={`${t('Contact')} (${t('Envoyer un email')})`}
            >
              {t('Contact')}
              <span className="sr-only"> ({t('Envoyer un email')})</span>
            </a>
          ) : (
            <a
              href="#"
              style={linkStyle}
              translate="no"
            >
              {t('Contact')}
            </a>
          )}
       
      </div>
    </footer>
  );
};

export default Footer;